import React, { useEffect } from "react";
import Heading from "../../components/Heading";
import { useRecoilState } from "recoil";
import { residentialAddressState } from "../../state/QuoteState";
import { ResidentialAddressType } from "../../interfaces/ResidentialAddress";
import Address from "./Address";

const ResidentialAddress = ({
  setIsFormValid,
}: {
  setIsFormValid: (value: boolean) => void;
}) => {
  const [residentialAddress, setResidentialAddress] = useRecoilState(
    residentialAddressState
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (
    value: string | boolean,
    field: keyof ResidentialAddressType
  ) => {
    setResidentialAddress((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <>
      <Heading>Residential Address</Heading>
      <Address
        data={residentialAddress}
        changeValue={handleInputChange}
        setIsAddressValid={setIsFormValid}
      />
    </>
  );
};

export default ResidentialAddress;
